/**
 * DocumentTitle — writes `«{screen} · Block&Taxes»` into the browser tab (#3621).
 *
 * Renders nothing. Re-runs when the route or the language changes
 * (`useRouteMeta` re-renders on `languageChanged`). A route still in
 * `PENDING_ROUTES` keeps whatever title the tab already has, and so does a title
 * whose catalogue has not loaded yet.
 */

import { useEffect } from 'react'

import { APP_NAME } from '@/shared/utils/constants'

import { useRouteMeta } from './useRouteMeta'

export const DocumentTitle: React.FC = () => {
  const { state, title } = useRouteMeta()

  useEffect(() => {
    if (state === 'pending' || title === null) return
    document.title = `${title} · ${APP_NAME}`
  }, [state, title])

  return null
}
